import React, {useEffect, useState} from "react"
import {Container, Row, Col, Toast, ToastBody, ToastHeader} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb"
import CardPricing, {CardContact} from "./CardPricing"

const Pricing = () => {
  document.title = "Pricing | Temperstack";
  const [pricingMessage, setPricingMessage] = useState("");
  const [messageHeader, setMessageHeader] = useState("");

  const pricings = [
    {
      id: 1,
      title: "Starter",
      description: "Free",
      icon: "bx-walk",
      price: "0",
      duration: "Per user per month",
      link: "",
      plan: "starter",
      features: [
        { title: "5 ALCOM Scores" },
        { title: "Unlimited User" },
        { title: "No Time Tracking" },
        { title: "Free Setup" },
      ],
    },
    {
      id: 2,
      title: "Basic",
      description: "Applicable to 50-100 production resources",
      icon: "bx-run",
      price: "10",
      duration: "Per user per month",
      plan: "Basic-Monthly",
      link: "https://10xbluejay.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=BasicMonthly-INR-Monthly&subscription_items[quantity][0]=5&layout=in_app",
      features: [
        { title: "Free Live Support" },
        { title: "Unlimited User" },
        { title: "Unlimited ALCOM Scores" },
        { title: "Bluejay Notifications" },
      ],
    },
    {
      id: 3,
      title: "Standard-Monthly",
      description: "Applicable to 100-500 resources",
      icon: "bx-cycling",
      price: "20",
      duration: "Per user per month",
      plan: "StandardMonthly",
      link: "https://10xbluejay.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=StandardMonthly-INR-Monthly&subscription_items[quantity][0]=5&utm_source=cb-app-copy",
      features: [
        { title: "Free Live Support" },
        { title: "Unlimited User" },
        { title: "Unlimited ALCOM Scores" },
        { title: "Bluejay Notifications" },
      ],
    },
  ];

  const Message = ({ message }) => (
    <Toast>{message}</Toast>
  );

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessageHeader("Success! 🎉");
      setPricingMessage("Payment Successful! You will receive an email confirmation.");
      hideToastAfterDelay();
    }

    if (query.get("canceled")) {
      setMessageHeader("Order canceled");
      setPricingMessage(
        "Payment Failed! Please retry!"
      );
      hideToastAfterDelay();
    }
  }, []);

  const [showToast, setShowToast] = useState(false);

  const closeToast = () => {
    setPricingMessage("");
  };

  const hideToastAfterDelay = () => {
    setTimeout(() => {
      setPricingMessage("")
    }, 10000);
  };

  return (
    <React.Fragment>
      {pricingMessage && (
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: "1005" }}>
          <Toast>
            <ToastHeader toggle={closeToast}>
              {messageHeader}
            </ToastHeader>
            <ToastBody>
              {pricingMessage}
            </ToastBody>
          </Toast>
        </div>
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Utility" breadcrumbItem="Pricing" />

          <Row className="justify-content-center">
            <Col lg={6}>
              <div className="text-center mb-5">
                <h4>Choose your pricing plan</h4>
              </div>
            </Col>
          </Row>

          <Row>
            {pricings.map((pricing, key) => (
              <CardPricing pricing={pricing} key={"_pricing_" + key} />
            ))}
            <CardContact />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default Pricing
